import UnreadCountQuery from '../components/siteadmin/AdminNotificationDropdown/getAdminNotificationUnreadCount.graphql';
import NotificationsQuery from '../components/siteadmin/AdminNotificationDropdown/getAdminNotifications.graphql';

// Rounds unread count up to next 10 for "See All" recentLimit (max 100).
export function ceilToNextTen(count) {
  if (!count || count <= 0) {
    return 10;
  }
  return Math.min(100, Math.ceil(count / 10) * 10);
}

/**
 * Mark admin notifications read when dropdown opens (car-document file icon + signup user icon).
 * Uses explicit query variables so react-apollo v1 refetch stays type-scoped.
 */
export async function markAdminNotificationsReadOnOpen({
  notificationType,
  unreadCountData,
  notificationsData,
  markAdminNotificationsRead,
}) {
  const countVariables = { type: notificationType };
  const listVariables = { type: notificationType, limit: 10 };
  const total = unreadCountData?.getAdminNotificationUnreadCount?.total || 0;
  const seeAllLimit = ceilToNextTen(total); // capture before mark-read for See All link

  if (total > 0 && markAdminNotificationsRead) {
    // Mark all unread as read when admin opens the dropdown.
    await markAdminNotificationsRead({
      variables: countVariables,
      refetchQueries: [ // keep apollo cache in sync (react-apollo v1)
        { query: UnreadCountQuery, variables: countVariables },
        { query: NotificationsQuery, variables: listVariables },
      ],
    });
  }

  if (unreadCountData?.refetch) {
    await unreadCountData.refetch(countVariables); // must pass type variable
  }
  if (notificationsData?.refetch) {
    await notificationsData.refetch(listVariables);
  }

  return { seeAllLimit };
}

export default markAdminNotificationsReadOnOpen;
